import Raven from "raven-js";

Raven.config(process.env.SENTRY_DSN, {
  release: process.env.SOURCE_VERSION
}).install();

var client;
if (process.env.SENTRY_DSN) {
  client = Raven;
} else {
  client = {
    captureException: console.error,
    captureMessage: console.log,
    setUserContext: () => {}
  };
}

function log(level, body, cb) {
  // If an error object, capture as an exception
  if (body.stack) {
    return client.captureException(body, cb);
  }

  if (typeof body !== "string") {
    body = JSON.stringify(body);
  }
  client.captureMessage(
    body,
    {
      level: level
    },
    cb
  );
}

// Hook into promise exceptions
window.onunhandledrejection = function(e) {
  // If not an error object, bundle it up ourselves
  if (!(e.reason instanceof Error) && e.reason && e.reason.message) {
    client.captureException(new Error(e.reason.message));
  } else {
    client.captureException(e.reason);
  }
};

export default {
  info: log.bind(null, "info"),
  warn: log.bind(null, "warning"),
  err: log.bind(null, "err"),
  setUserContext: client.setUserContext.bind(client)
};



// WEBPACK FOOTER //
// ./src/app/logger.js